<div class="popup-container" *ngIf="!loadingFinish">
  <div class="close-popup-container pt-3">
    <div class="close-popup-button" [mat-dialog-close]="true">
      <mat-icon class="close-icon">close</mat-icon>
    </div>
  </div>
  <div class="title-container">
    <span>Liquidaciones</span>
  </div>
  <form class="filter-container" [formGroup]="form" *ngIf="form && !isLoading">
    <mat-form-field class="fiserv45-lt" appearance="outline" style="width: 100%; margin-bottom: 20px">
      <mat-select #branchMatSelect [(value)]="branchOfficeSelect" formControlName="branchSelected"
        (selectionChange)="selectionChangeBranch()"
        placeholder="{{ translate('pages.pay_order.branchs.select_branch') }}">
        <mat-option>
          <ngx-mat-select-search formControlName="searchBranch"
            placeholderLabel="{{ translate('pages.pay_order.branchs.search_branch') }}"
            noEntriesFoundLabel="{{ translate('pages.pay_order.branchs.branch_not_found') }}">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let branchOffice of branchFilter" [value]="branchOffice.value">
          {{ branchOffice.display }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="!branchSelected.untouched && branchSelected.invalid">
        {{ 'pages.pay_order.branchs.branch_error' | translate }}</mat-error>
    </mat-form-field>
    <!--Fecha-->
    <mat-form-field appearance="outline" class="filter-container-form-field">
      <mat-label>Fecha Desde</mat-label>
      <div (click)="matDateToggleFrom.datepicker.open()">
        <input style="cursor: pointer !important" matInput [matDatepicker]="picker" formControlName="dateDesde"
          [placeholder]="'Fecha Desde'" readonly />
      </div>
      <mat-datepicker-toggle #matDateToggleFrom matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-container-form-field-date--to">
      <mat-label>Fecha Hasta</mat-label>
      <div (click)="matDateToggleTo.datepicker.open()">
        <input style="cursor: pointer !important" matInput [matDatepicker]="picker2" formControlName="dateHasta"
          [placeholder]="'Fecha Hasta'" readonly [max]="maxDateTo" [min]="form.get('dateDesde')?.value"
          [disabled]="!form.get('dateDesde').value" />
      </div>
      <mat-datepicker-toggle #matDateToggleTo matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
      <mat-error *ngIf="form.get('dateHasta')?.touched && form.get('dateHasta')?.invalid">
        Campo requerido
      </mat-error>
    </mat-form-field>
    <mat-error *ngIf="form.errors?.dateRangeError" class="error-dates">
      Debes seleccionar un rango de fechas de 31 días o menos.
    </mat-error>
    <button *ngIf="form && !resumentResponse" class="generar-resumen-button" mat-stroked-button color="primary"
      (click)="generarLiquidacion()" [disabled]="!form.valid" [class.disabled]="!form.valid">
      Descargar
    </button>
  </form>
</div>

<div *ngIf="loadingFinish" class="p-4">
  <mat-spinner [diameter]="80"></mat-spinner>
</div>